/**
 * Module-level Bullrun app config. Mirrors the observability capture()
 * pattern: each app calls setBullrunConfig() at module load, and shared
 * screens/utilities read via getBullrunConfig() — including from callbacks
 * that run outside the React tree (e.g. deep-link handlers).
 *
 * All fields are optional on read: shared code should tolerate empty
 * strings so mobile-web / test environments work without a full wiring.
 */
const DEFAULT_CONFIG = {
    appDomain: "",
    onrampCompleteUrl: "",
    crossmintApiKey: "",
};
let _config = DEFAULT_CONFIG;
export function setBullrunConfig(config) {
    _config = { ...DEFAULT_CONFIG, ..._config, ...config };
}
export function getBullrunConfig() {
    return _config;
}
